import { render, staticRenderFns } from "./OrderReferenceTableItem.vue?vue&type=template&id=f1331c7c&"
import script from "./OrderReferenceTableItem.vue?vue&type=script&lang=js&"
export * from "./OrderReferenceTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports